// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"0c7f5af6","284":"397cafa4","387":"1cede3a0","734":"d9e9e660","941":"281bbad4"}[chunkId] + ".chunk.js";
};